import { FormValues } from 'screens/Applications&WorkOrders/StepsLayout/Constants/formikData';
import { ProductWithPlanFields } from 'types/product';
import { generateProductApplicationId } from '../../../helpers';

// eslint-disable-next-line import/prefer-default-export
export const generateInitialValues = (
  application: FormValues,
  product: ProductWithPlanFields,
  sessionQuantityMode: string
): ProductWithPlanFields => {
  return {
    id: product.id,
    productApplicationId:
      product.productApplicationId || generateProductApplicationId(product.id),
    name: product.name,
    manufacturer: product.manufacturer,
    productType: product.productType,
    isInUse: product.isInUse,

    quantityMode: product.quantityMode || sessionQuantityMode,

    // totals
    ratePerAcre: product.ratePerAcre ?? '',
    totalProduct: product.totalProduct ?? '',

    ratePerAreaUnit: product.ratePerAreaUnit || product.stdunit || '',
    ratePerTank: product.ratePerTank ?? '',
    ratePerTankUnit: product.ratePerTankUnit || product.stdunit || '',
    totalProductUnit: product.totalProductUnit || product.stdpackageunit || '',

    // prices
    // Use typeof check to preserve priceValue of 0 (which is falsy but a valid saved value)
    priceValue:
      typeof product.priceValue === 'number'
        ? product.priceValue
        : product.averagePricePerUnit ?? 0,

    priceUnit:
      product.priceUnit ||
      product.averagePricePerUnitUnit ||
      product.stdpackageunit ||
      '',

    averagePricePerUnit: product.averagePricePerUnit,
    averagePricePerUnitUnit: product.averagePricePerUnitUnit,
    saveAsNewListPrice: product.saveAsNewListPrice || false,

    // area
    totalArea: application?.totalArea || 0,
    totalAppliedAcreage:
      application?.totalAppliedAcreage || application?.totalArea || 0,
    appliedAreaValue:
      product.appliedAreaValue || application?.totalAppliedAcreage || 0,
    coveragePercent: product.coveragePercent || 100,

    // other
    custom: product.custom || false,
    applicationMethod:
      product.applicationMethod ?? application?.applicationMethod ?? '',
    targetPests: product.targetPests || [],
    registrationNumber: product.registrationNumber || '',
    // Plans-only (see `PlanProductFields.applicationCount`) — defaults to 1 so a
    // brand-new product (no saved count yet) starts as a single application.
    applicationCount: product.applicationCount ?? 1,
    timingEvent: product.timingEvent || '',
    timingEventTag: product.timingEventTag || '',
    targetDateEpoch: product.targetDateEpoch,

    // for calculations
    density: product.density || product.stdfactor || 1,
    stdpackageunit: product.stdpackageunit || '',
    stdunit: product.stdunit || '',
    stdfactor: product.stdfactor || 1,
    isCarrier: product.isCarrier || false,
    isHidden: product.isHidden || false
  };
};
